//#region src/utils/id.ts
var e = () => crypto.getRandomValues(new Uint32Array(1))[0] >>> 1, t = () => crypto.randomUUID();
//#endregion
export { t as n, e as t };

//# sourceMappingURL=id-Cl4PImxR.js.map